<template>
    <v-sheet>
        <v-toolbar dense elevation="1">
            <v-toolbar-title>
                Draft Records
            </v-toolbar-title>
        </v-toolbar>
        <v-simple-table dense fixed-header>
            <thead>
                <tr>
                    <th>Code</th>
                    <th>Document Date</th>
                    <th>Date</th>
                    <th>Created By</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="draft in drafts" :key="draft.id" @click="selectDraft(draft.number)" v-ripple>
                    <td>{{draft.number_f}}</td>
                    <td>{{draft.document_date}}</td>
                    <td>{{draft.created_at}}</td>
                    <td>{{draft.created_by}}</td>
                </tr>
            </tbody>
        </v-simple-table>
        <v-toolbar bottom dense>
            <v-btn text @click="$emit('close')">
                close
            </v-btn>
        </v-toolbar>
    </v-sheet>
</template>

<script>
export default {
    name: "StockJournalDrafts",
    props: {
        drafts: Array,
    },
    methods: {
        selectDraft(number) {
            this.$emit('stockJournalSelected',number)
        }
    }
}
</script>

<style>

</style>